import { render, staticRenderFns } from "./CreateTarifvertragModal.vue?vue&type=template&id=90ff3f8c&scoped=true&"
import script from "./CreateTarifvertragModal.vue?vue&type=script&lang=js&"
export * from "./CreateTarifvertragModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateTarifvertragModal.vue?vue&type=style&index=0&id=90ff3f8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ff3f8c",
  null
  
)

export default component.exports